export class AddressTypeReferenceModel {
    public addressTypeCode: string;
    public addressTypeName: string;
    public primaryFlag: boolean;
    public sortSequence: number;
}